import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Glossary } from '../shared/models/glossary.model';
import { Note } from '../shared/models/note.model';
import { Translation } from '../shared/models/translation.model';

@Injectable({
  providedIn: 'root'
})
export class TraduzioniService {

  constructor(private http: HttpClient) { }

  /**
   * Metodo che gestisce la chiamata GET per il recupero della stringa di traduzione
   * @param id {number} identificativo della stringa
   */
  getTranslationString(id: number): Observable<Translation> {
    return this.http.get<Translation>('service/translation/' + id);
  }

  /**
   * Metodo che gestisce la chiamata POST per la modifica della stringa ebraica relativa a una certa sezione
   * @param id {number} identificativo della stringa
   * @param newOriginal {string} nuova parte ebraica in HTML
   */
  updateOriginal(id: number, newOriginal: string): Observable<Translation> {
    return this.http.post<Translation>(
      'service/translation/' + id + '/original',
      newOriginal
    );
  }

  /**
   * Metodo che gestisce la chiamata POST per la modifica della traduzione di una data sezione
   * @param id {number} identificativo della stringa
   * @param newTranslation {string} nuova traduzione in HTML
   */
  updateTranslation(id: number, newTranslation: string): Observable<Translation> {
    return this.http.post<Translation>(
      'service/translation/' + id + '/translation',
      newTranslation
    );
  }

  /**
   * Metodo che gestisce la chiamata GET per recuperare le note associate a una stringa di traduzione
   * @param translationId {number} id della stringa di traduzione
   */
  getNotes(translationId: number): Observable<Note[]> {
    return this.http.get<Note[]>('service/translation/' + translationId + '/notes');
  }

  /**
   * Metodo che gestisce la chiamata GET per recuperare i glossari taggati e associati alla stringa
   * @param translationId {number} id della stringa di traduzione
   */
  getGlossaries(translationId: number): Observable<Glossary[]> {
    return this.http.get<Glossary[]>('service/translation/' + translationId + '/glossaries');
  }

  //TODO: servirà nel pannello traduzioni
  /**
   * Metodo che gestisce la chiamata GET per dissociare una nota dalla stringa di traduzione
   * @param translationId {number} id della stringa di traduzione
   * @param noteId {number} id della nota da dissociare
   */
  getDissociateNote(translationId: number, noteId: number): Observable<Translation> {
    return this.http.get<Translation>('service/translation/' + translationId + '/notes/remove/' + noteId);
  }

  /**
   * Metodo che gestisce la chiamata GET per dissociare un glossario dalla stringa di traduzione
   * @param translationId {number} id della stringa di traduzione
   * @param glossaryId {number} id del glossario da dissociare
   */
  getDissociateGlossary(translationId: number, glossaryId: number): Observable<Translation> {
    return this.http.get<Translation>('service/translation/' + translationId + '/glossaries/remove/' + glossaryId);
  }
}
